import axios from "axios";
import * as Sentry from "@sentry/react";

const API_URL_TEST = "https://qa-webapi.easyrent.com.mt";
const API_URL_LIVE = "https://webapi.easyrent.com.mt";
let API_URL = "";
const host = document.location.host;

if (
  host.toLowerCase().startsWith("qa-web.") ||
  host.toLowerCase().startsWith("localhost")
) {
  API_URL = API_URL_LIVE;
} else if (host.toLowerCase().startsWith("easysale")) {
  API_URL = API_URL_LIVE;
} else {
  API_URL = API_URL_LIVE;
}

let caller = axios.create({
  baseURL: API_URL,
});

// Sunucu (5xx) ve ağ hatalarını Sentry'ye gönderir. 4xx cevaplar form doğrulama
// mesajlarıdır (kullanıcı hatası), gönderilmez. Aynı hata nesnesi daha sonra
// yakalanmadan kalırsa Sentry onu ikinci kez göndermez.
caller.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (!axios.isCancel(error) && (!status || status >= 500)) {
      const method = (error.config?.method || "get").toUpperCase();
      const path = (error.config?.url || "").split("?")[0];
      Sentry.captureException(error, {
        tags: { api_status: status || "network" },
        extra: { method, url: error.config?.url },
        // Tüm API hataları tek issue'da birleşmesin: endpoint bazında grupla
        fingerprint: ["api-error", method, path.replace(/\d+/g, ":id"), String(status || "network")],
      });
    }
    return Promise.reject(error);
  }
);

export default caller;
